import api from "../../api/api";

export default {
  state: {
    notificationsNumber: 0,
    showNotifications: false,
    notifications: null,
  },
  mutations: {
    setNotificationsNumber(state, value){
      state.notificationsNumber = value;
    },
    setShowNotifications(state, value) {
      state.showNotifications = value;
    },
    setNotifications(state, value) {
      state.notifications = value;
    },
  },
  actions: {
    getNotificationNumber: ({commit}) => {
      api.get("/notifications/notificationsNumber").then((r) => {
        commit('setNotificationsNumber', r.data);
      });
    },
    seeNotifications: async ({commit}) => {
      const response = await api.get('/notifications/getNotifications');
      commit('setNotifications', null);
      commit('setNotifications', response.data);
      commit('setShowNotifications', true);
      commit('setNotificationsNumber', 0);
    },
    hideNotifications: ({commit}) => {
      commit('setShowNotifications', false);
      commit('setNotifications', null);
    },
  },
  getters: {
    notifications: (state) => { return state.notificationsNumber; },
    shouldShowNotifications: (state) => {return state.showNotifications;},
    notificationList: (state) => {return state.notifications;},
  },
  namespaced: true,
};